(function () {
  const SAVED_SEARCHES_KEY = 'label_source_saved_searches_v1';
  const MAX_SAVED_SEARCHES = 20;

  let injectTimer = null;
  let observerStarted = false;

  /*
    Searchanise URL filter map.

    This uses the URL keys to build the saved search summary.
    The selected values stay dynamic, so we are NOT hardcoding product types,
    categories, colours, brands, conditions, etc.
  */
  const SEARCHANISE_FILTER_MAP = {
    rb_filter_metafield_0eb46d8d21f6346011f28d0279e94fa3: {
      key: 'gender',
      label: 'Gender',
      allLabel: 'All genders'
    },

    rb_filter_metafield_ec6ec4840042d5c86dd3fa0a6d8095b1: {
      key: 'category',
      label: 'Category',
      allLabel: 'All categories'
    },

    rb_filter_metafield_2f8b0d4c75f83174b0128f7e33bd2766: {
      key: 'productType',
      label: 'Product type',
      allLabel: 'All product types'
    },

    rb_vendor: {
      key: 'brand',
      label: 'Brand',
      allLabel: 'All brands'
    },

    rb_filter_option_6f6cb72d544962fa333e2e34ce64f719: {
      key: 'size',
      label: 'Size',
      allLabel: 'All sizes'
    },

    rb_filter_option_dfe6076e1d429c24edcbb2686bb39567: {
      key: 'colour',
      label: 'Colour',
      allLabel: 'All colours'
    },


    rb_filter_metafield_9e24a7dfb0603a85a909b12f7da503fd: {
      key: 'condition',
      label: 'Condition',
      allLabel: 'All conditions'
    }
  };

  const FILTER_ORDER = [
    {
      key: 'gender',
      label: 'Gender',
      allLabel: 'All genders'
    },
    {
      key: 'category',
      label: 'Category',
      allLabel: 'All categories'
    },
    {
      key: 'productType',
      label: 'Product type',
      allLabel: 'All product types'
    },
    {
      key: 'brand',
      label: 'Brand',
      allLabel: 'All brands'
    },
    {
      key: 'size',
      label: 'Size',
      allLabel: 'All sizes'
    },
    {
      key: 'colour',
      label: 'Colour',
      allLabel: 'All colours'
    },
    {
      key: 'price',
      label: 'Price range',
      allLabel: 'All prices'
    },
    {
      key: 'condition',
      label: 'Condition',
      allLabel: 'All conditions'
    }
  ];

  function getSavedSearches() {
    try {
      const savedSearches = JSON.parse(localStorage.getItem(SAVED_SEARCHES_KEY)) || [];
      return Array.isArray(savedSearches) ? savedSearches : [];
    } catch (error) {
      return [];
    }
  }

  function saveSavedSearches(savedSearches) {
    localStorage.setItem(SAVED_SEARCHES_KEY, JSON.stringify(savedSearches));
  }

  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function cleanFilterValue(value) {
    let text = cleanText(value);

    text = text
      .replace(/^remove\s+/i, '')
      .replace(/\s+remove$/i, '')
      .replace(/^×\s*/, '')
      .replace(/\s*×$/, '')
      .replace(/^x\s+/i, '')
      .replace(/\s+x$/i, '')
      .replace(/\(\s*\d+\s*\)$/g, '')
      .replace(/\s+\(\s*\d+\s*\)$/g, '')
      .replace(/([A-Za-z'’])\d{2,6}$/g, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();

    const lowerText = text.toLowerCase();

    if (!text) return '';
    if (lowerText === 'reset filters') return '';
    if (lowerText === 'reset filter') return '';
    if (lowerText === 'clear filters') return '';
    if (lowerText === 'clear all') return '';
    if (lowerText.includes('reset filters')) return '';
    if (lowerText.includes('clear filters')) return '';
    if (lowerText.includes('clear all')) return '';

    return text;
  }

function getCurrentRelativeUrl() {
  const url = new URL(window.location.href);

  const exactParamsToRemove = [
    'rb_price',
    'sort_by',
    'sort_order'
  ];

  exactParamsToRemove.forEach(param => {
    url.searchParams.delete(param);
  });

  Array.from(url.searchParams.keys()).forEach(key => {
    const lowerKey = key.toLowerCase();

    if (lowerKey.includes('price')) {
      url.searchParams.delete(key);
    }

    if (lowerKey.includes('sort')) {
      url.searchParams.delete(key);
    }

    if (lowerKey.includes('order')) {
      url.searchParams.delete(key);
    }
  });

  return url.pathname + url.search + url.hash;
}

  function isShoppingSearchPage() {
    const path = window.location.pathname.toLowerCase();
    const search = window.location.search.toLowerCase();
    const hash = window.location.hash.toLowerCase();

    if (path.startsWith('/products')) return false;
    if (path.startsWith('/cart')) return false;
    if (path.startsWith('/checkout')) return false;
    if (path.startsWith('/account')) return false;
    if (path.startsWith('/pages/favourites')) return false;

    if (path.startsWith('/collections')) return true;
    if (path.startsWith('/search')) return true;
    if (path.startsWith('/pages/search-results-page')) return true;
    if (path.startsWith('/pages/shop')) return true;
    if (path.startsWith('/pages/shop-all')) return true;

    if (search.includes('q=')) return true;
    if (search.includes('query=')) return true;
    if (search.includes('keyword=')) return true;
    if (search.includes('search')) return true;
    if (search.includes('snize')) return true;
    if (search.includes('rb_')) return true;

    if (hash.includes('q=')) return true;
    if (hash.includes('query=')) return true;
    if (hash.includes('search')) return true;
    if (hash.includes('snize')) return true;
    if (hash.includes('rb_')) return true;

    return false;
  }

  function hasSearchaniseOnPage() {
    return !!(
      document.querySelector('.snize-main-panel') ||
      document.querySelector('#snize-search-results-grid-mode') ||
      document.querySelector('.snize-search-results') ||
      document.querySelector('[class*="snize"]')
    );
  }

  function getCombinedUrlParams() {
    const params = new URLSearchParams(window.location.search);

    if (window.location.hash && window.location.hash.includes('=')) {
      const hashString = window.location.hash.replace(/^#/, '').replace(/^\?/, '');
      const hashParams = new URLSearchParams(hashString);

      hashParams.forEach((value, key) => {
        params.append(key, value);
      });
    }

    return params;
  }

  function getUrlSearchTerm() {
    const params = getCombinedUrlParams();

    return (
      params.get('q') ||
      params.get('query') ||
      params.get('keyword') ||
      params.get('search') ||
      ''
    );
  }

  function createEmptyBuckets() {
    const buckets = {};

    FILTER_ORDER.forEach(layer => {
      buckets[layer.key] = [];
    });

    return buckets;
  }

  function addBucketValue(buckets, key, value) {
    const cleanedValue = cleanFilterValue(value);

    if (!key) return;
    if (!cleanedValue) return;
    if (!buckets[key]) return;
    if (buckets[key].includes(cleanedValue)) return;

    buckets[key].push(cleanedValue);
  }

  function splitFilterValue(value) {
    return String(value || '')
      .split('|')
      .map(item => cleanFilterValue(item))
      .filter(Boolean);
  }

  function formatPriceNumber(value) {
    const cleanValue = String(value || '').replace(/[^\d.]/g, '');

    if (!cleanValue) return '';

    const number = Number(cleanValue);

    if (!Number.isFinite(number)) return '';

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: 0
    }).format(number);
  }

  function getPriceRangeFromValue(value) {
    const rawValue = String(value || '').trim();

    if (!rawValue) return '';

    const parts = rawValue.split(',').map(part => part.trim());

    if (parts.length < 2) return '';

    const min = formatPriceNumber(parts[0]);
    const max = formatPriceNumber(parts[1]);

    if (min && max) return `${min} - ${max}`;
    if (min) return `Over ${min}`;
    if (max) return `Under ${max}`;

    return '';
  }

  function collectFromUrlParams(buckets) {
    const params = getCombinedUrlParams();

    params.forEach((value, key) => {
      const lowerKey = key.toLowerCase();

      if (!value) return;

      if (lowerKey === 'page') return;
      if (lowerKey === 'tab') return;
      if (lowerKey === 'q') return;
      if (lowerKey === 'query') return;
      if (lowerKey === 'keyword') return;
      if (lowerKey === 'search') return;

      if (lowerKey === 'sort_by') return;
      if (lowerKey === 'sort_order') return;
      if (lowerKey.includes('sort')) return;
      if (lowerKey.includes('order')) return;
      if (lowerKey === 'rb_price') return;
if (lowerKey.includes('price')) return;

      const mappedFilter = SEARCHANISE_FILTER_MAP[lowerKey];

      if (!mappedFilter) return;

      if (mappedFilter.key === 'price') {
        const priceRange = getPriceRangeFromValue(value);

        if (priceRange) {
          buckets.price = [priceRange];
        }

        return;
      }

      splitFilterValue(value).forEach(item => {
        addBucketValue(buckets, mappedFilter.key, item);
      });
    });
  }

  function getSortTextForSummary() {
    const params = getCombinedUrlParams();

    const sortBy = (params.get('sort_by') || '').toLowerCase().trim();
    const sortOrder = (params.get('sort_order') || '').toLowerCase().trim();

    if (sortBy === 'price' && sortOrder === 'asc') return 'Price low to high';
    if (sortBy === 'price' && sortOrder === 'desc') return 'Price high to low';

    if (sortBy === 'created' && sortOrder === 'asc') return 'Old to new';
    if (sortBy === 'created' && sortOrder === 'desc') return 'New to old';

    if (sortBy === 'published_at' && sortOrder === 'asc') return 'Old to new';
    if (sortBy === 'published_at' && sortOrder === 'desc') return 'New to old';

    if (sortBy === 'title' && sortOrder === 'asc') return 'A to Z';
    if (sortBy === 'title' && sortOrder === 'desc') return 'Z to A';

    if (sortBy.includes('recent') || sortBy.includes('reduced') || sortBy.includes('drop')) {
      return 'Recently reduced';
    }

    return 'New to old';
  }

  function getFilterSummaryLines() {
    const buckets = createEmptyBuckets();
    const lines = [];

    collectFromUrlParams(buckets);

    const searchTerm = getUrlSearchTerm();

    if (searchTerm) {
      lines.push(`Search: ${searchTerm}`);
    }

    FILTER_ORDER.forEach(layer => {
      const values = [...new Set(
        buckets[layer.key]
          .map(cleanFilterValue)
          .filter(Boolean)
      )];

      if (values.length) {
        lines.push(`${layer.label}: ${values.join(', ')}`);
      } else {
        lines.push(`${layer.label}: ${layer.allLabel}`);
      }
    });


    return lines;
  }

  function getSavedSearchTitle() {
    const searchTerm = getUrlSearchTerm();

    if (searchTerm) return searchTerm;

    return 'Saved search';
  }

  function currentSearchIsWorthSaving() {
    const url = getCurrentRelativeUrl().toLowerCase();

    if (getUrlSearchTerm()) return true;
    if (url.includes('snize')) return true;
    if (url.includes('filter')) return true;
    if (url.includes('sort')) return true;
    if (url.includes('pf_')) return true;
    if (url.includes('rb_')) return true;
    if (url.includes('/collections')) return true;
    if (url.includes('/search')) return true;

    return false;
  }

  function createSavedSearchObject() {
    return {
      id: `saved_search_${Date.now()}`,
      title: getSavedSearchTitle(),
      url: getCurrentRelativeUrl(),
      summary: getFilterSummaryLines(),
      created_at: Date.now()
    };
  }

  function isCurrentSearchSaved() {
    const url = getCurrentRelativeUrl();

    return getSavedSearches().some(search => search.url === url);
  }

  function toggleCurrentSearch() {
    const currentUrl = getCurrentRelativeUrl();
    let savedSearches = getSavedSearches();

    const alreadySaved = savedSearches.some(search => search.url === currentUrl);

    if (alreadySaved) {
      savedSearches = savedSearches.filter(search => search.url !== currentUrl);
      saveSavedSearches(savedSearches);
      updateSaveButtonState();
      return;
    }

    const newSearch = createSavedSearchObject();

    savedSearches = savedSearches.filter(search => search.url !== newSearch.url);
    savedSearches.unshift(newSearch);
    savedSearches = savedSearches.slice(0, MAX_SAVED_SEARCHES);

    saveSavedSearches(savedSearches);
    updateSaveButtonState();
  }

  function updateSaveButtonState() {
    const button = document.querySelector('[data-ls-save-search]');

    if (!button) return;

    const saved = isCurrentSearchSaved();

    button.classList.toggle('is-saved', saved);
    button.textContent = saved ? 'Saved' : 'Save search';
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
  }

  function injectSaveSearchButton() {
    if (!isShoppingSearchPage()) return;
    if (!hasSearchaniseOnPage()) return;

    const toolbar =
      document.querySelector('.snize-main-panel.ls-snize-has-sort-shortcut') ||
      document.querySelector('.snize-main-panel');

    const existing = document.querySelector('.ls-save-search-wrap');

    if (!currentSearchIsWorthSaving()) {
      if (existing) existing.remove();

      document.querySelectorAll('.snize-main-panel.ls-snize-has-save-search').forEach(panel => {
        panel.classList.remove('ls-snize-has-save-search');
      });

      return;
    }

    if (!toolbar) return;

    toolbar.classList.add('ls-snize-has-save-search');

    if (existing) {
      if (!toolbar.contains(existing)) {
        existing.remove();
      } else {
        updateSaveButtonState();
        return;
      }
    }

    const wrap = document.createElement('div');
    wrap.className = 'ls-save-search-wrap ls-save-search-wrap--toolbar';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ls-save-search-button';
    button.setAttribute('data-ls-save-search', '');
    button.setAttribute('aria-pressed', 'false');
    button.textContent = 'Save search';

    wrap.appendChild(button);

    const filtersButton = toolbar.querySelector('.snize-main-panel-mobile-filters');

    if (filtersButton) {
      toolbar.insertBefore(wrap, filtersButton);
    } else {
      toolbar.appendChild(wrap);
    }

    updateSaveButtonState();
  }

  function scheduleInjectSaveSearchButton() {
    if (injectTimer) return;

    injectTimer = setTimeout(function () {
      injectTimer = null;
      injectSaveSearchButton();
    }, 200);
  }

  function startObserver() {
    if (observerStarted) return;

    observerStarted = true;

    const observer = new MutationObserver(function (mutations) {
      let shouldRun = false;

      mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
          shouldRun = true;
        }
      });

      if (shouldRun) {
        scheduleInjectSaveSearchButton();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('click', function (event) {
    const saveSearchButton = event.target.closest('[data-ls-save-search]');

    if (!saveSearchButton) return;

    event.preventDefault();
    event.stopPropagation();

    toggleCurrentSearch();
  });

  document.addEventListener('DOMContentLoaded', function () {
    injectSaveSearchButton();
    startObserver();

    setTimeout(injectSaveSearchButton, 500);
    setTimeout(injectSaveSearchButton, 1500);
    setTimeout(injectSaveSearchButton, 3000);
  });

  window.addEventListener('load', function () {
    injectSaveSearchButton();
  });

  window.addEventListener('popstate', function () {
    setTimeout(injectSaveSearchButton, 300);
  });

  window.addEventListener('hashchange', function () {
    setTimeout(injectSaveSearchButton, 300);
  });
})();